// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public//images//heros/hero-image_2.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;1,200;1,400;1,500;1,600&family=Viga&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--bg-primary: #454b72;
	--color-text: #e2e8f0;
	--color-text-dark: #020617;
	--bg-blue-dark: #081b29;
	--font-poppins: "Poppins", sans-serif;
	--font-viga: "Viga", sans-serif;
	--primary-color: #ffc334;
}

* {
	box-sizing: border-box;
	text-decoration: none;
}
html {
	scroll-behavior: smooth;
}

body {
	background: #454b72;
	margin: 0;
}

.skip-content {
	position: absolute;
	top: -50px;
	left: 0px;
	padding: 8px;
	background-color: var(--primary-color);
	color: white;
	z-index: 99999;
}
.skip-content:focus {
	position: static;
	width: auto;
	height: auto;
}

/* style navbar start */
header .navbar {
	background: var(--bg-primary);
	display: flex;
	justify-content: space-between;
	font-family: var(--font-poppins);
	align-items: center;
	padding: 1.3rem 7.5%;
	border-bottom: 1px solid var(--primary-color);
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	z-index: 9999;
	-webkit-box-shadow: 10px 10px 12px 0px rgba(0, 0, 0, 0.75);
	-moz-box-shadow: 10px 10px 12px 0px rgba(0, 0, 0, 0.75);
	box-shadow: 10px 10px 12px 0px rgba(0, 0, 0, 0.75);
}
header .navbar .navbar-brands {
	font-size: 1.8rem;
	font-weight: 600;
	font-family: var(--font-viga);
	margin-bottom: 0;
	color: var(--primary-color);
	letter-spacing: 1px;
	font-style: italic;
}
header .navbar .navbar-brands span {
	display: block;
	text-align: center;
	letter-spacing: 2px;
	color: var(--primary-color);
	color: var(--color-text);
	line-height: 0.8;
}

header .navbar .navbar-nav .nav-link {
	color: var(--color-text);
	font-size: 1.3rem;
	margin: 0 1rem;
	padding: 10px;
	position: relative;
	min-width: 44px;
	min-height: 44px;
}
header .navbar .navbar-nav .nav-link:hover {
	color: var(--primary-color);
}

header .navbar .navbar-nav .nav-link::before {
	position: absolute;
	content: "";
	bottom: -3px;
	left: 50%;
	width: 0;
	height: 2px;
	color: var(--primary-color);
	transition: width 0.4s ease;
	transform: translateX(-50%);
}
header .navbar .navbar-nav .nav-link.active::before {
	width: 50%;
	background-color: var(--primary-color);
}
header .navbar .navbar-nav .nav-link.active {
	color: var(--primary-color);
	font-weight: 500;
}

#Hamburger-menu {
	position: relative;
	width: 45px;
	height: 30px;
	border-radius: 0;
	padding: 0;
	cursor: pointer;
	border: none;
	background: transparent;
	color: transparent;
}
#Box-Hamburger span {
	background-color: var(--primary-color);
	box-shadow: 0 0 8px var(--bg-blue-dark);
	border: 1px solid var(--bg-blue-dark);
	width: 45px;
	height: 7px;
}
#Box-Hamburger span.atas {
	position: absolute;
	top: 5%;
	left: 50%;
	transform: translateX(-50%);
	border-radius: 1rem;
	transition: 0.5s ease;
}
#Box-Hamburger span.tengah {
	position: absolute;
	top: 40%;
	left: 50%;
	transform: translateX(-50%);
	border-radius: 1rem;
	transition: 1s ease;
}
#Box-Hamburger span.bawah {
	position: absolute;
	top: 80%;
	left: 50%;
	transform: translateX(-50%);
	border-radius: 1rem;
	transition: 0.5s ease;
}
#Box-Hamburger {
	display: none;
}

#Box-Hamburger.active span.atas {
	transform: rotate(45deg);
	transform-origin: top bottom;
	top: 10px;
	left: 0;
	border: 1px solid var(--pink);
	box-shadow: 0 0 10px var(--pink);
}
#Box-Hamburger.active span.bawah {
	transform: rotate(-45deg);
	transform-origin: top left;
	top: 28px;
	left: 3px;
	border: 1px solid var(--pink);
	box-shadow: 0 0 10px var(--pink);
}
#Box-Hamburger.active span.tengah {
	transform: translateX(-700%);
	filter: blur(10px);
	opacity: 0;
	background-color: var(--pink);
	transition-delay: 0.1s;
}
/* style navbar end */

/* style home start */
#Hero {
	min-height: 100vh;
	display: flex;
	align-items: center;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	background-attachment: fixed;
}
#Hero::after {
	content: "";
	position: absolute;
	display: block;
	width: 100%;
	height: 100%;
	background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.5));
}

#Hero .HeroKonten {
	padding: 1.2rem 6.8%;
	font-family: var(--font-viga);
	z-index: 1;
	color: var(--color-text);
	max-width: 65rem;
	overflow: hidden;
}
#Hero .HeroKonten h1 {
	font-size: 5.5rem;
	text-shadow: 0 0 10px var(--color-text-dark);
	line-height: 1;
	margin-bottom: 1rem;
}
#Hero .HeroKonten span {
	color: var(--primary-color);
	font-style: italic;
}
#Hero .HeroKonten p {
	font-size: 1.1rem;
	text-shadow: 0 0 10px var(--color-text-dark);
}

#Hero .HeroKonten .BOXbtn-home .btn-home:hover {
	background: var(--color-text);
	transform: scale(1.05);
	transition: all 0.3s ease-in-out;
	border: 2px solid var(--primary-color);
}
#Hero .HeroKonten .BOXbtn-home .btn-home {
	background: var(--primary-color);
	font-size: 1.2rem;
	min-width: 44px;
	min-height: 44px;
	border-radius: 10px;
	padding: 10px;
	font-weight: 600;
	cursor: pointer;
	transition: 0.3s ease;
	border: 2px solid var(--color-text);
}
#Hero .HeroKonten .BOXbtn-home .btn-home a {
	color: var(--color-text-dark);
	font-family: var(--font-poppins);
}
#Hero .HeroKonten .BOXbtn-home .btn-home:active {
	background: var(--primary-color);
	border: 2px solid var(--color-text);
}
/* style home end */

/* style favorite start */
#Favorite {
	padding: 8rem 5.5% 1.4rem;
}
#Favorite .explore {
	color: var(--color-text);
	font-family: var(--font-poppins);
	letter-spacing: 1px;
	font-size: 2.5rem;
	text-align: center;
	margin-bottom: 3rem;
}
#Favorite .explore span {
	color: var(--primary-color);
}

#Favorite .row {
	display: flex;
	justify-content: center;
	margin-top: 4rem;
	position: relative;
	flex-wrap: wrap;
}
#Favorite .row .conten {
	position: relative;
	display: flex;
	justify-content: center;
	max-width: 32%;
	margin-bottom: 1.5rem;
}

#Favorite .row .card .card-body {
	max-width: 85%;
}
#Favorite .row .card .card-img {
	max-width: 85%;
	border-radius: 10px;
	justify-content: center;
	text-align: center;
	display: flex;
}
#Favorite .row .card .card-body .card-city {
	position: absolute;
	top: 0;
	background: var(--primary-color);
	padding: 0.8rem;
	font-size: 1.1rem;
	font-family: var(--font-viga);
	font-weight: 300;
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
	width: 8rem;
}
#Favorite .row .card .card-body .card-rating {
	font-family: var(--font-poppins);
	font-size: 1.1rem;
	color: var(--color-text);
	margin: 0.2rem 0;
	display: flex;
	align-items: center;
}

#Favorite .row .card .card-body .card-rating img {
	margin-right: 5px;
}
#Favorite .row .card .card-body .card-name {
	margin: 0.2rem 0;
	font-size: 1.8rem;
	color: var(--primary-color);
	font-family: var(--font-poppins);
}
#Favorite .row .card .card-body p {
	color: var(--color-text);
	margin: 0.2rem auto 0.5rem;
	font-family: var(--font-poppins);
	text-align: justify;
}
/* style favorite end */

/* style contact start */
#Contact {
	padding: 8rem 7%;
	background: #3e4574;
	padding-bottom: 18rem;
}

#Contact .kontak {
	color: var(--color-text);
	font-family: var(--font-poppins);
	letter-spacing: 1px;
	font-size: 2.8rem;
	text-align: center;
	margin-bottom: 3rem;
}
#Contact .kontak span {
	color: var(--primary-color);
}

#Contact .row {
	display: flex;
	margin: 1.5rem;
	/* flex-wrap: wrap; */
}
#Contact .row .gmaps {
	object-fit: cover;
	flex: 1 1 40rem;
	width: 100%;
	height: 450px;
	border-radius: 15px;
}
#Contact .row form {
	flex: 1 1 40rem;
	padding-left: 1.5rem;
}
#Contact .row form .group-input input {
	width: 100%;
	padding: 1.2rem;
	border-radius: 10px;
	background: var(--color-text);
	font-size: 1.2rem;
}

#Contact .row form .group-input label,
.textareaLabel {
	position: absolute;
	top: 50%;
	left: 15px;
	transform: translateY(-50%);
	transition: 0.6s ease;
	pointer-events: none;
	font-family: var(--font-poppins);
	font-weight: 300;
}
#Contact .row form .group-input input:focus ~ label,
#Contact .row form .group-input input:valid ~ label {
	top: -0.1rem;
	left: 10px;
	color: var(--primary-color);
	font-size: 1.2rem;
	font-weight: 500;
}

#Contact .row form .group-input {
	display: flex;
	padding: 1rem 0.5rem;
	width: 100%;
	position: relative;
	margin-bottom: 10px;
}
#Contact .row form .container-group {
	width: 100%;
	display: flex;
	position: relative;
}
#Contact .row form .container-group textarea {
	width: 100%;
	padding: 1rem;
	border-radius: 10px;
	height: 190px;
	margin: 1.5rem 10px 1rem;
	background: var(--color-text);
	font-size: 1.2rem;
}
#Contact .row form .container-group .textareaLabel {
	top: 18%;
}
#Contact .row form .container-group textarea:focus ~ .textareaLabel,
#Contact .row form .container-group textarea:valid ~ .textareaLabel {
	top: 5px;
	color: var(--primary-color);
	font-size: 1.2rem;
	font-weight: 500;
}
#Contact .row form .container-btn-form {
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
}
#Contact .container-btn-form .btn-form {
	background: var(--primary-color);
	font-size: 1.2rem;
	min-width: 44px;
	min-height: 44px;
	border-radius: 10px;
	padding: 10px;
	font-weight: 600;
	cursor: pointer;
	transition: 0.3s ease;
	border: 2px solid var(--color-text);
}
#Contact .container-btn-form .btn-form:hover {
	background: var(--color-text);
	transform: scale(1.05);
	transition: all 0.3s ease-in-out;
	border: 2px solid var(--primary-color);
}
/* style contact end */

footer {
	padding: 2rem 7%;
}
footer .ftr-sosmed,
footer .Tautan_Link {
	display: flex;
	justify-content: center;
	align-items: center;
}

footer .ftr-sosmed a,
footer .Tautan_Link a {
	margin: 1rem 1.2rem;
	font-family: var(--font-viga);
	font-size: 1.1rem;
	color: var(--color-text);
}
footer .Tautan_Link a:hover {
	color: var(--primary-color);
	text-decoration: underline;
}
footer .cpRight {
	margin-top: 1rem;
}
footer .cpRight h4 {
	text-align: center;
	margin: 0;
	font-family: var(--font-poppins);
	color: var(--color-text);
	font-weight: 300;
}

/* break point laptop */
@media (max-width: 1399.98px) {
	html {
		font-size: 90%;
	}
}
/* break point tablet */
@media (max-width: 991.98px) {
	html {
		font-size: 85%;
	}
	#Box-Hamburger {
		display: inline-block;
	}
	header .navbar .navbar-nav {
		position: absolute;
		top: 120%;
		transform: translateX(100%);
		background: var(--color-text);
		border: 2px solid var(--primary-color);
		box-shadow: 0 0 10px var(--primary-color);
		border-radius: 10px;
		width: 50%;
		height: 50vh;
		right: -50%;
		padding: 1.3rem;
		transition: 1.5s ease;
		transition-delay: 0.2s;
		opacity: 0;
		filter: blur(15px);
	}
	header .navbar .navbar-nav .nav-link {
		display: block;
		margin: 5px 0;
		font-size: 1.4rem;
		color: var(--color-text-dark);
		font-weight: 600;
		padding: 10px;
	}

	header .navbar .navbar-nav.active {
		transition: 1s ease;
		filter: blur(0);
		opacity: 1;
		transform: translateX(3%);
		right: 0;
	}

	header .navbar .navbar-nav .nav-link.active::before {
		display: none;
	}
	#Favorite .row {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		margin-top: 4rem;
		position: relative;
	}
	#Favorite .row .conten,
	#Favorite .row .conten .card .card-body,
	#Favorite .row .conten .card .card-img {
		max-width: 100%;
	}
	#Contact .row {
		flex-wrap: wrap;
	}
	#Contact .row form .group-input {
		width: 100%;
	}
	#Contact .row form {
		padding: 0;
	}
	#Contact .row form {
		padding-top: 1rem;
		padding-bottom: 1rem;
	}
}

/* break point mobile */
@media (max-width: 767.98px) {
	html {
		font-size: 75%;
	}
	#Contact .row form .container-group {
		width: 100%;
		display: block;
	}
	#Contact .row form .container-group textarea {
		margin: 0;
	}
	#Contact .row form .group-input {
		padding: 1rem 0;
	}
	#Contact {
		padding: 8rem 1.5%;
	}
	#Contact .row .gmaps {
		margin-bottom: 2rem;
		height: 350px;
	}
}
/* STYLE SCROLL BAR */
::-webkit-scrollbar {
	width: 0.7em;
}

::-webkit-scrollbar-thumb {
	background-color: var(--primary-color);
	border-radius: 5px;
}

::-webkit-scrollbar-track {
	background: var(--color-text);
	border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AACA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,0BAA0B;CAC1B,uBAAuB;CACvB,qCAAqC;CACrC,+BAA+B;CAC/B,wBAAwB;AACzB;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;AACtB;AACA;CACC,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,YAAY;CACZ,sCAAsC;CACtC,YAAY;CACZ,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,YAAY;AACb;;AAEA,uBAAuB;AACvB;CACC,6BAA6B;CAC7B,aAAa;CACb,8BAA8B;CAC9B,gCAAgC;CAChC,mBAAmB;CACnB,oBAAoB;CACpB,6CAA6C;CAC7C,eAAe;CACf,MAAM;CACN,QAAQ;CACR,OAAO;CACP,aAAa;CACb,0DAA0D;CAC1D,uDAAuD;CACvD,kDAAkD;AACnD;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,6BAA6B;CAC7B,gBAAgB;CAChB,2BAA2B;CAC3B,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB,2BAA2B;CAC3B,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;CACxB,iBAAiB;CACjB,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,SAAS;CACT,QAAQ;CACR,WAAW;CACX,2BAA2B;CAC3B,2BAA2B;CAC3B,2BAA2B;AAC5B;AACA;CACC,UAAU;CACV,sCAAsC;AACvC;AACA;CACC,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,UAAU;CACV,eAAe;CACf,YAAY;CACZ,uBAAuB;CACvB,kBAAkB;AACnB;AACA;CACC,sCAAsC;CACtC,uCAAuC;CACvC,qCAAqC;CACrC,WAAW;CACX,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;CACT,2BAA2B;CAC3B,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,2BAA2B;CAC3B,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,2BAA2B;CAC3B,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,aAAa;AACd;;AAEA;CACC,wBAAwB;CACxB,4BAA4B;CAC5B,SAAS;CACT,OAAO;CACP,6BAA6B;CAC7B,gCAAgC;AACjC;AACA;CACC,yBAAyB;CACzB,0BAA0B;CAC1B,SAAS;CACT,SAAS;CACT,6BAA6B;CAC7B,gCAAgC;AACjC;AACA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,UAAU;CACV,6BAA6B;CAC7B,sBAAsB;AACvB;AACA,qBAAqB;;AAErB,qBAAqB;AACrB;CACC,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,yDAAgE;CAChE,4BAA4B;CAC5B,sBAAsB;CACtB,2BAA2B;CAC3B,4BAA4B;AAC7B;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,mEAAmE;AACpE;;AAEA;CACC,oBAAoB;CACpB,6BAA6B;CAC7B,UAAU;CACV,wBAAwB;CACxB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,iBAAiB;CACjB,4CAA4C;CAC5C,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,2BAA2B;CAC3B,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,4CAA4C;AAC7C;;AAEA;CACC,6BAA6B;CAC7B,sBAAsB;CACtB,gCAAgC;CAChC,sCAAsC;AACvC;AACA;CACC,gCAAgC;CAChC,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,aAAa;CACb,gBAAgB;CAChB,eAAe;CACf,qBAAqB;CACrB,mCAAmC;AACpC;AACA;CACC,6BAA6B;CAC7B,gCAAgC;AACjC;AACA;CACC,gCAAgC;CAChC,mCAAmC;AACpC;AACA,mBAAmB;;AAEnB,yBAAyB;AACzB;CACC,yBAAyB;AAC1B;AACA;CACC,wBAAwB;CACxB,gCAAgC;CAChC,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,gCAAgC;CAChC,eAAe;CACf,iBAAiB;CACjB,6BAA6B;CAC7B,gBAAgB;CAChB,6BAA6B;CAC7B,gCAAgC;CAChC,WAAW;AACZ;AACA;CACC,gCAAgC;CAChC,iBAAiB;CACjB,wBAAwB;CACxB,gBAAgB;CAChB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,2BAA2B;CAC3B,gCAAgC;AACjC;AACA;CACC,wBAAwB;CACxB,0BAA0B;CAC1B,gCAAgC;CAChC,mBAAmB;AACpB;AACA,uBAAuB;;AAEvB,wBAAwB;AACxB;CACC,gBAAgB;CAChB,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,wBAAwB;CACxB,gCAAgC;CAChC,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,iBAAiB;CACjB,eAAe;CACf,WAAW;CACX,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,oBAAoB;AACrB;AACA;CACC,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,6BAA6B;CAC7B,iBAAiB;AAClB;;AAEA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,2BAA2B;CAC3B,qBAAqB;CACrB,oBAAoB;CACpB,gCAAgC;CAChC,gBAAgB;AACjB;AACA;;CAEC,YAAY;CACZ,UAAU;CACV,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,oBAAoB;CACpB,WAAW;CACX,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,wBAAwB;CACxB,6BAA6B;CAC7B,iBAAiB;AAClB;AACA;CACC,QAAQ;AACT;AACA;;CAEC,QAAQ;CACR,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,gCAAgC;CAChC,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,aAAa;CACb,gBAAgB;CAChB,eAAe;CACf,qBAAqB;CACrB,mCAAmC;AACpC;AACA;CACC,6BAA6B;CAC7B,sBAAsB;CACtB,gCAAgC;CAChC,sCAAsC;AACvC;AACA,sBAAsB;;AAEtB;CACC,gBAAgB;AACjB;AACA;;CAEC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;;CAEC,mBAAmB;CACnB,6BAA6B;CAC7B,iBAAiB;CACjB,wBAAwB;AACzB;AACA;CACC,2BAA2B;CAC3B,0BAA0B;AAC3B;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,gCAAgC;CAChC,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA,uBAAuB;AACvB;CACC;EACC,cAAc;CACf;AACD;AACA,uBAAuB;AACvB;CACC;EACC,cAAc;CACf;CACA;EACC,qBAAqB;CACtB;CACA;EACC,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,sCAAsC;EACtC,yCAAyC;EACzC,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;CACnB;CACA;EACC,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;CACd;;CAEA;EACC,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,QAAQ;CACT;;CAEA;EACC,aAAa;CACd;CACA;EACC,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;CACnB;CACA;;;EAGC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,WAAW;CACZ;CACA;EACC,UAAU;CACX;CACA;EACC,iBAAiB;EACjB,oBAAoB;CACrB;AACD;;AAEA,uBAAuB;AACvB;CACC;EACC,cAAc;CACf;CACA;EACC,WAAW;EACX,cAAc;CACf;CACA;EACC,SAAS;CACV;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,mBAAmB;EACnB,aAAa;CACd;AACD;AACA,qBAAqB;AACrB;CACC,YAAY;AACb;;AAEA;CACC,sCAAsC;CACtC,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;CAC7B,kBAAkB;AACnB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;1,200;1,400;1,500;1,600&family=Viga&display=swap\");\n:root {\n\t--bg-primary: #454b72;\n\t--color-text: #e2e8f0;\n\t--color-text-dark: #020617;\n\t--bg-blue-dark: #081b29;\n\t--font-poppins: \"Poppins\", sans-serif;\n\t--font-viga: \"Viga\", sans-serif;\n\t--primary-color: #ffc334;\n}\n\n* {\n\tbox-sizing: border-box;\n\ttext-decoration: none;\n}\nhtml {\n\tscroll-behavior: smooth;\n}\n\nbody {\n\tbackground: #454b72;\n\tmargin: 0;\n}\n\n.skip-content {\n\tposition: absolute;\n\ttop: -50px;\n\tleft: 0px;\n\tpadding: 8px;\n\tbackground-color: var(--primary-color);\n\tcolor: white;\n\tz-index: 99999;\n}\n.skip-content:focus {\n\tposition: static;\n\twidth: auto;\n\theight: auto;\n}\n\n/* style navbar start */\nheader .navbar {\n\tbackground: var(--bg-primary);\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tfont-family: var(--font-poppins);\n\talign-items: center;\n\tpadding: 1.3rem 7.5%;\n\tborder-bottom: 1px solid var(--primary-color);\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tleft: 0;\n\tz-index: 9999;\n\t-webkit-box-shadow: 10px 10px 12px 0px rgba(0, 0, 0, 0.75);\n\t-moz-box-shadow: 10px 10px 12px 0px rgba(0, 0, 0, 0.75);\n\tbox-shadow: 10px 10px 12px 0px rgba(0, 0, 0, 0.75);\n}\nheader .navbar .navbar-brands {\n\tfont-size: 1.8rem;\n\tfont-weight: 600;\n\tfont-family: var(--font-viga);\n\tmargin-bottom: 0;\n\tcolor: var(--primary-color);\n\tletter-spacing: 1px;\n\tfont-style: italic;\n}\nheader .navbar .navbar-brands span {\n\tdisplay: block;\n\ttext-align: center;\n\tletter-spacing: 2px;\n\tcolor: var(--primary-color);\n\tcolor: var(--color-text);\n\tline-height: 0.8;\n}\n\nheader .navbar .navbar-nav .nav-link {\n\tcolor: var(--color-text);\n\tfont-size: 1.3rem;\n\tmargin: 0 1rem;\n\tpadding: 10px;\n\tposition: relative;\n\tmin-width: 44px;\n\tmin-height: 44px;\n}\nheader .navbar .navbar-nav .nav-link:hover {\n\tcolor: var(--primary-color);\n}\n\nheader .navbar .navbar-nav .nav-link::before {\n\tposition: absolute;\n\tcontent: \"\";\n\tbottom: -3px;\n\tleft: 50%;\n\twidth: 0;\n\theight: 2px;\n\tcolor: var(--primary-color);\n\ttransition: width 0.4s ease;\n\ttransform: translateX(-50%);\n}\nheader .navbar .navbar-nav .nav-link.active::before {\n\twidth: 50%;\n\tbackground-color: var(--primary-color);\n}\nheader .navbar .navbar-nav .nav-link.active {\n\tcolor: var(--primary-color);\n\tfont-weight: 500;\n}\n\n#Hamburger-menu {\n\tposition: relative;\n\twidth: 45px;\n\theight: 30px;\n\tborder-radius: 0;\n\tpadding: 0;\n\tcursor: pointer;\n\tborder: none;\n\tbackground: transparent;\n\tcolor: transparent;\n}\n#Box-Hamburger span {\n\tbackground-color: var(--primary-color);\n\tbox-shadow: 0 0 8px var(--bg-blue-dark);\n\tborder: 1px solid var(--bg-blue-dark);\n\twidth: 45px;\n\theight: 7px;\n}\n#Box-Hamburger span.atas {\n\tposition: absolute;\n\ttop: 5%;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tborder-radius: 1rem;\n\ttransition: 0.5s ease;\n}\n#Box-Hamburger span.tengah {\n\tposition: absolute;\n\ttop: 40%;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tborder-radius: 1rem;\n\ttransition: 1s ease;\n}\n#Box-Hamburger span.bawah {\n\tposition: absolute;\n\ttop: 80%;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tborder-radius: 1rem;\n\ttransition: 0.5s ease;\n}\n#Box-Hamburger {\n\tdisplay: none;\n}\n\n#Box-Hamburger.active span.atas {\n\ttransform: rotate(45deg);\n\ttransform-origin: top bottom;\n\ttop: 10px;\n\tleft: 0;\n\tborder: 1px solid var(--pink);\n\tbox-shadow: 0 0 10px var(--pink);\n}\n#Box-Hamburger.active span.bawah {\n\ttransform: rotate(-45deg);\n\ttransform-origin: top left;\n\ttop: 28px;\n\tleft: 3px;\n\tborder: 1px solid var(--pink);\n\tbox-shadow: 0 0 10px var(--pink);\n}\n#Box-Hamburger.active span.tengah {\n\ttransform: translateX(-700%);\n\tfilter: blur(10px);\n\topacity: 0;\n\tbackground-color: var(--pink);\n\ttransition-delay: 0.1s;\n}\n/* style navbar end */\n\n/* style home start */\n#Hero {\n\tmin-height: 100vh;\n\tdisplay: flex;\n\talign-items: center;\n\tbackground-image: url(../public//images//heros/hero-image_2.jpg);\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-position: center;\n\tbackground-attachment: fixed;\n}\n#Hero::after {\n\tcontent: \"\";\n\tposition: absolute;\n\tdisplay: block;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.5));\n}\n\n#Hero .HeroKonten {\n\tpadding: 1.2rem 6.8%;\n\tfont-family: var(--font-viga);\n\tz-index: 1;\n\tcolor: var(--color-text);\n\tmax-width: 65rem;\n\toverflow: hidden;\n}\n#Hero .HeroKonten h1 {\n\tfont-size: 5.5rem;\n\ttext-shadow: 0 0 10px var(--color-text-dark);\n\tline-height: 1;\n\tmargin-bottom: 1rem;\n}\n#Hero .HeroKonten span {\n\tcolor: var(--primary-color);\n\tfont-style: italic;\n}\n#Hero .HeroKonten p {\n\tfont-size: 1.1rem;\n\ttext-shadow: 0 0 10px var(--color-text-dark);\n}\n\n#Hero .HeroKonten .BOXbtn-home .btn-home:hover {\n\tbackground: var(--color-text);\n\ttransform: scale(1.05);\n\ttransition: all 0.3s ease-in-out;\n\tborder: 2px solid var(--primary-color);\n}\n#Hero .HeroKonten .BOXbtn-home .btn-home {\n\tbackground: var(--primary-color);\n\tfont-size: 1.2rem;\n\tmin-width: 44px;\n\tmin-height: 44px;\n\tborder-radius: 10px;\n\tpadding: 10px;\n\tfont-weight: 600;\n\tcursor: pointer;\n\ttransition: 0.3s ease;\n\tborder: 2px solid var(--color-text);\n}\n#Hero .HeroKonten .BOXbtn-home .btn-home a {\n\tcolor: var(--color-text-dark);\n\tfont-family: var(--font-poppins);\n}\n#Hero .HeroKonten .BOXbtn-home .btn-home:active {\n\tbackground: var(--primary-color);\n\tborder: 2px solid var(--color-text);\n}\n/* style home end */\n\n/* style favorite start */\n#Favorite {\n\tpadding: 8rem 5.5% 1.4rem;\n}\n#Favorite .explore {\n\tcolor: var(--color-text);\n\tfont-family: var(--font-poppins);\n\tletter-spacing: 1px;\n\tfont-size: 2.5rem;\n\ttext-align: center;\n\tmargin-bottom: 3rem;\n}\n#Favorite .explore span {\n\tcolor: var(--primary-color);\n}\n\n#Favorite .row {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: 4rem;\n\tposition: relative;\n\tflex-wrap: wrap;\n}\n#Favorite .row .conten {\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: center;\n\tmax-width: 32%;\n\tmargin-bottom: 1.5rem;\n}\n\n#Favorite .row .card .card-body {\n\tmax-width: 85%;\n}\n#Favorite .row .card .card-img {\n\tmax-width: 85%;\n\tborder-radius: 10px;\n\tjustify-content: center;\n\ttext-align: center;\n\tdisplay: flex;\n}\n#Favorite .row .card .card-body .card-city {\n\tposition: absolute;\n\ttop: 0;\n\tbackground: var(--primary-color);\n\tpadding: 0.8rem;\n\tfont-size: 1.1rem;\n\tfont-family: var(--font-viga);\n\tfont-weight: 300;\n\tborder-top-right-radius: 10px;\n\tborder-bottom-right-radius: 10px;\n\twidth: 8rem;\n}\n#Favorite .row .card .card-body .card-rating {\n\tfont-family: var(--font-poppins);\n\tfont-size: 1.1rem;\n\tcolor: var(--color-text);\n\tmargin: 0.2rem 0;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n#Favorite .row .card .card-body .card-rating img {\n\tmargin-right: 5px;\n}\n#Favorite .row .card .card-body .card-name {\n\tmargin: 0.2rem 0;\n\tfont-size: 1.8rem;\n\tcolor: var(--primary-color);\n\tfont-family: var(--font-poppins);\n}\n#Favorite .row .card .card-body p {\n\tcolor: var(--color-text);\n\tmargin: 0.2rem auto 0.5rem;\n\tfont-family: var(--font-poppins);\n\ttext-align: justify;\n}\n/* style favorite end */\n\n/* style contact start */\n#Contact {\n\tpadding: 8rem 7%;\n\tbackground: #3e4574;\n\tpadding-bottom: 18rem;\n}\n\n#Contact .kontak {\n\tcolor: var(--color-text);\n\tfont-family: var(--font-poppins);\n\tletter-spacing: 1px;\n\tfont-size: 2.8rem;\n\ttext-align: center;\n\tmargin-bottom: 3rem;\n}\n#Contact .kontak span {\n\tcolor: var(--primary-color);\n}\n\n#Contact .row {\n\tdisplay: flex;\n\tmargin: 1.5rem;\n\t/* flex-wrap: wrap; */\n}\n#Contact .row .gmaps {\n\tobject-fit: cover;\n\tflex: 1 1 40rem;\n\twidth: 100%;\n\theight: 450px;\n\tborder-radius: 15px;\n}\n#Contact .row form {\n\tflex: 1 1 40rem;\n\tpadding-left: 1.5rem;\n}\n#Contact .row form .group-input input {\n\twidth: 100%;\n\tpadding: 1.2rem;\n\tborder-radius: 10px;\n\tbackground: var(--color-text);\n\tfont-size: 1.2rem;\n}\n\n#Contact .row form .group-input label,\n.textareaLabel {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 15px;\n\ttransform: translateY(-50%);\n\ttransition: 0.6s ease;\n\tpointer-events: none;\n\tfont-family: var(--font-poppins);\n\tfont-weight: 300;\n}\n#Contact .row form .group-input input:focus ~ label,\n#Contact .row form .group-input input:valid ~ label {\n\ttop: -0.1rem;\n\tleft: 10px;\n\tcolor: var(--primary-color);\n\tfont-size: 1.2rem;\n\tfont-weight: 500;\n}\n\n#Contact .row form .group-input {\n\tdisplay: flex;\n\tpadding: 1rem 0.5rem;\n\twidth: 100%;\n\tposition: relative;\n\tmargin-bottom: 10px;\n}\n#Contact .row form .container-group {\n\twidth: 100%;\n\tdisplay: flex;\n\tposition: relative;\n}\n#Contact .row form .container-group textarea {\n\twidth: 100%;\n\tpadding: 1rem;\n\tborder-radius: 10px;\n\theight: 190px;\n\tmargin: 1.5rem 10px 1rem;\n\tbackground: var(--color-text);\n\tfont-size: 1.2rem;\n}\n#Contact .row form .container-group .textareaLabel {\n\ttop: 18%;\n}\n#Contact .row form .container-group textarea:focus ~ .textareaLabel,\n#Contact .row form .container-group textarea:valid ~ .textareaLabel {\n\ttop: 5px;\n\tcolor: var(--primary-color);\n\tfont-size: 1.2rem;\n\tfont-weight: 500;\n}\n#Contact .row form .container-btn-form {\n\ttext-align: center;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n#Contact .container-btn-form .btn-form {\n\tbackground: var(--primary-color);\n\tfont-size: 1.2rem;\n\tmin-width: 44px;\n\tmin-height: 44px;\n\tborder-radius: 10px;\n\tpadding: 10px;\n\tfont-weight: 600;\n\tcursor: pointer;\n\ttransition: 0.3s ease;\n\tborder: 2px solid var(--color-text);\n}\n#Contact .container-btn-form .btn-form:hover {\n\tbackground: var(--color-text);\n\ttransform: scale(1.05);\n\ttransition: all 0.3s ease-in-out;\n\tborder: 2px solid var(--primary-color);\n}\n/* style contact end */\n\nfooter {\n\tpadding: 2rem 7%;\n}\nfooter .ftr-sosmed,\nfooter .Tautan_Link {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\nfooter .ftr-sosmed a,\nfooter .Tautan_Link a {\n\tmargin: 1rem 1.2rem;\n\tfont-family: var(--font-viga);\n\tfont-size: 1.1rem;\n\tcolor: var(--color-text);\n}\nfooter .Tautan_Link a:hover {\n\tcolor: var(--primary-color);\n\ttext-decoration: underline;\n}\nfooter .cpRight {\n\tmargin-top: 1rem;\n}\nfooter .cpRight h4 {\n\ttext-align: center;\n\tmargin: 0;\n\tfont-family: var(--font-poppins);\n\tcolor: var(--color-text);\n\tfont-weight: 300;\n}\n\n/* break point laptop */\n@media (max-width: 1399.98px) {\n\thtml {\n\t\tfont-size: 90%;\n\t}\n}\n/* break point tablet */\n@media (max-width: 991.98px) {\n\thtml {\n\t\tfont-size: 85%;\n\t}\n\t#Box-Hamburger {\n\t\tdisplay: inline-block;\n\t}\n\theader .navbar .navbar-nav {\n\t\tposition: absolute;\n\t\ttop: 120%;\n\t\ttransform: translateX(100%);\n\t\tbackground: var(--color-text);\n\t\tborder: 2px solid var(--primary-color);\n\t\tbox-shadow: 0 0 10px var(--primary-color);\n\t\tborder-radius: 10px;\n\t\twidth: 50%;\n\t\theight: 50vh;\n\t\tright: -50%;\n\t\tpadding: 1.3rem;\n\t\ttransition: 1.5s ease;\n\t\ttransition-delay: 0.2s;\n\t\topacity: 0;\n\t\tfilter: blur(15px);\n\t}\n\theader .navbar .navbar-nav .nav-link {\n\t\tdisplay: block;\n\t\tmargin: 5px 0;\n\t\tfont-size: 1.4rem;\n\t\tcolor: var(--color-text-dark);\n\t\tfont-weight: 600;\n\t\tpadding: 10px;\n\t}\n\n\theader .navbar .navbar-nav.active {\n\t\ttransition: 1s ease;\n\t\tfilter: blur(0);\n\t\topacity: 1;\n\t\ttransform: translateX(3%);\n\t\tright: 0;\n\t}\n\n\theader .navbar .navbar-nav .nav-link.active::before {\n\t\tdisplay: none;\n\t}\n\t#Favorite .row {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tjustify-content: center;\n\t\tmargin-top: 4rem;\n\t\tposition: relative;\n\t}\n\t#Favorite .row .conten,\n\t#Favorite .row .conten .card .card-body,\n\t#Favorite .row .conten .card .card-img {\n\t\tmax-width: 100%;\n\t}\n\t#Contact .row {\n\t\tflex-wrap: wrap;\n\t}\n\t#Contact .row form .group-input {\n\t\twidth: 100%;\n\t}\n\t#Contact .row form {\n\t\tpadding: 0;\n\t}\n\t#Contact .row form {\n\t\tpadding-top: 1rem;\n\t\tpadding-bottom: 1rem;\n\t}\n}\n\n/* break point mobile */\n@media (max-width: 767.98px) {\n\thtml {\n\t\tfont-size: 75%;\n\t}\n\t#Contact .row form .container-group {\n\t\twidth: 100%;\n\t\tdisplay: block;\n\t}\n\t#Contact .row form .container-group textarea {\n\t\tmargin: 0;\n\t}\n\t#Contact .row form .group-input {\n\t\tpadding: 1rem 0;\n\t}\n\t#Contact {\n\t\tpadding: 8rem 1.5%;\n\t}\n\t#Contact .row .gmaps {\n\t\tmargin-bottom: 2rem;\n\t\theight: 350px;\n\t}\n}\n/* STYLE SCROLL BAR */\n::-webkit-scrollbar {\n\twidth: 0.7em;\n}\n\n::-webkit-scrollbar-thumb {\n\tbackground-color: var(--primary-color);\n\tborder-radius: 5px;\n}\n\n::-webkit-scrollbar-track {\n\tbackground: var(--color-text);\n\tborder-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
